<template>
  <div
      class="h-100 d-flex ai-center"
      :class="{'d-none':hasLead}">
    <div class="x-header-link-container m-l-auto d-none:mo">
      <div @click="toggleUserTypeValue">
        <router-link
            v-if="isProHomepage"
            :to="{ name: 'homepage' }"
            :class="[isWhiteHeader ? 'header-link':'x-header-link']"
            class="m-r-2"
        >
          Hire A Pro
        </router-link>
        <router-link
            v-else
            :to="{ name: 'pro-homepage' }"
            :class="[isWhiteHeader ? 'header-link':'x-header-link']"
            class="m-r-2"
        >
          I'm A Pro
        </router-link>
      </div>
      <span
          v-if="!isLoginPage"
          class="x-header-link"
          selenium="header-sign-in-link"
          @click="handleLoginClick">
        <span class="header-link--filled">Sign In</span>
      </span>
    </div>
    <div class="x-header-link-container m-l-auto d-none:t">
      <header-menu>
        <template slot="button">
          <span class="x-header-link">
            <vk-icon name="hamburger"/>
          </span>
        </template>
        <template slot="drawer">
          <div @touchend="toggleUserTypeValue">
            <router-link
                v-if="isProHomepage"
                :to="{ name: 'homepage' }"
                class="x-header-menu-link"
                role="menuitem"
            >
              Hire A Pro
            </router-link>
            <router-link
                v-else
                :to="{ name: 'pro-homepage' }"
                class="x-header-menu-link"
                role="menuitem"
            >
              I'm A Pro
            </router-link>
          </div>
          <div>
            <router-link
                v-if="!isLoginPage"
                class="x-header-menu-link"
                role="menuitem"
                selenium="header-sign-in-link"
                :to="{
                  name: 'login',
                  params: {
                    proLogin: !!isProHomepage,
                    showRequestSearchPage: !isProHomepage,
                  },
                  query: {
                    redirect: $route.fullPath,
                  },
                }"
            >
              Sign In
            </router-link>
          </div>
        </template>
      </header-menu>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Storage from '@homeservices/tool-kit/storage/local-storage';
import HeaderMenu from '@/layouts/components/HeaderMenu';
import AppLoginForm from '@/components/AppLoginForm';

const USER_TYPE = 'USER_TYPE_VALUE';
export default {
  name: 'app-header-public',
  components: {
    HeaderMenu,
    AppLoginForm,
  },
  computed: {
    isLoginPage () {
      return this.$route.name === 'login' || this.$route.name === 'forgot-password';
    },
    isWhiteHeader () {
      return this.$route.name === 'homepage' || this.$route.name === 'consumer::dashboard';
    },
    ...mapGetters('homepage', ['isProHomepage']),
    hasLead () {
      return this.$route.query && this.$route.query.lead;
    },
  },
  methods: {
    handleLoginClick () {
      this.$router.push({
        name: 'login',
        params: {
          proLogin: !!this.isProHomepage,
          showRequestSearchPage: !this.isProHomepage,
        },
        query: {
          redirect: this.$route.fullPath,
        },
      });
    },
    toggleUserTypeValue () {
      const userType = Storage.get(USER_TYPE) === 'PRO_USER' ? 'CUSTOMER_USER' : 'PRO_USER';
      Storage.set(USER_TYPE, userType);
    },
  },
};
</script>
